module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAABCBAMAAAA1Y5IbAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURUdwTCwsLC0tLS4uLi0tLS0tLS4uLjAwMCkpKS0tLS4uLlRZObUAAAAKdFJOUwBAv4DZUvAQKafLpPitAAAArElEQVQ4y2Ngn7IKE3g2MDCUrcIGMhgYZmGVWMnA4IVVYhUDw6pVqQzoIGTVKgGgRACGBCtEQgBDgmFUYlRiVGJoSjgpYQCIBFZAnsRkYwxArHMrcEi0rPLAKsHutWpZATYJYOm1ygCbBDMuCY5ViFIQ1fJZq5ZgdxWzijmhYOeASKhjSHCCJLJWLcOIDmDpXcCghTVwgc6QwiqxFOjhLCziy0A+ZRTEBECHAgA3i0al8QRmzAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoneHomePage/practice-3.png
// module id = OGaz
// module chunks = 0